import enumBase from './EnumBase';

export default class BulkSendStatistic extends enumBase {
  static TOTAL = 'total';
  static PROCESSING = 'processing';
  static IN_TRANSIT = 'in-transit';
  static COMPLETED = 'completed';
  static FAILED = 'failed';

  static values = [
    this.TOTAL,
    this.PROCESSING,
    this.IN_TRANSIT,
    this.COMPLETED,
    this.FAILED,
  ];

  static chartOrder = [
    this.PROCESSING,
    this.IN_TRANSIT,
    this.FAILED,
    this.COMPLETED,
  ];

  static getText(value, i18n) {
    return i18n.t(`bulkSendDetails.statistics.${value}`) || value;
  }
}
